<template>
  <div class="empty__result__container">
    <div class="empty__result__container-left ">
      <div class="content">
        <p>Oops!</p>

        <div>
          <p>
            We couldn’t find what you were looking for
          </p>
          <p class="p-empty">
            Please refine your search criteria or try again later
          </p>
        </div>
      </div>
    </div>
    <div class="empty__result__container-right">
      <img
        src="../../assets/images/search-result-empty.svg"
        alt="search-result-empty"
      />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/general/emptyResult.vue